export const setList = (state, payload) => state.list = payload;
export const setDocumentTemplate = (state, payload) => state.documentTemplate = payload;
